module.exports = __webpack_public_path__ + "img/Frame 44.9afb0583.svg";